import { getChatServiceURL } from "../util";
import { localStorage } from './sa';
const BASE_URL = getChatServiceURL();
const makeRequest = async ({ method = "get", url }) => {
    const data = await (await fetch(BASE_URL + url, {
        method,
    })).json();
    return data;
};
export const shouldDisplayChat = async (company, facia) => {
    const originURL = localStorage.getItem('smartagent_connection/global');
    const response = await makeRequest({
        url: `/companies/${company}/facia/${facia ?? company}/chatFlowId?referrerURL=${originURL ?? encodeURI(window.location.href)}`
    });
    return { ...response, displayOnLoad: !!originURL };
};
